module.exports = __webpack_public_path__ + "img/logo.d6221cd3.png";